/* eslint-disable import/prefer-default-export */
import { toValue } from '@vueuse/core';
import { GIFT_CARD_TYPE } from '../../constants/giftcard';
import { useGiftBasicPreselect } from './useGiftBasicPreselect';
import { useGiftConsolidatedPreselect } from './useGiftConsolidatedPreselect';

const picked = {
  [GIFT_CARD_TYPE.BASIC]: useGiftBasicPreselect,
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: useGiftConsolidatedPreselect,
  [GIFT_CARD_TYPE.E_GIFT_CARD]: useGiftBasicPreselect,
};

/**
 * @param {import('@vueuse/core').MaybeRefOrGetter<GIFT_CARD_TYPE>} giftCardType
 * @param {Partial<Record<import('../../types').GIFT_CARD_FIELDS, string>>} values
 * @param {import('@vueuse/core').MaybeRefOrGetter<null | number | string>} selectedGift
 */
export const useGiftPreselect = (giftCardType = GIFT_CARD_TYPE.BASIC, values, selectedGift) => picked[toValue(giftCardType)](values, selectedGift);
